import React from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import LotInventoryTable from '../components/LotInventoryTable';
import './InventoryDetails.css';

const InventoryDetails = () => {
  // Capture the Inventory_id parameter from the URL
  const { compound_lot_id } = useParams();

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        width: "100%"
      }}
    >
      <div className="InventoryDetails">
        <Navigation />
        <LotInventoryTable compound_lot_id={compound_lot_id}/>

      </div>
    </div>
  );
};

export default InventoryDetails;
